import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.css';
import './assets/styles/reset.css';
import EmersonFooter from './components/emersonWrapper/footer';
import EmersonHeader from './components/emersonWrapper/header';
import App from './App';

import './i18n';

//const element = <App />;
//ReactDOM.render(element, document.getElementById('root'));

ReactDOM.render(
    <React.StrictMode>
        
        <App />
     
    </React.StrictMode>,

    document.getElementById('root')
  );
